<af-main-container [title]="'i18n_af_subjects' | translate"
                   [showBreadcrumbs]="false"
                   [showBackButton]="false"
                   [buttonLabel]="activeTab !== 'tabSuspiciousNumbers'
                       && activeTab !== 'tabLoans' && isNpckAdmin && ('i18n_af_buttonCreateSubject' | translate)"
                   (buttonClickListener)="navigateToCreateSubject()">
    <mat-tab-group mat-align-tabs="start" animationDuration="0"
                   class="mt-16 w-100 h-100 hide-scroll-bar"
                   [(selectedIndex)]="selectedTabIndex"
                   (selectedIndexChange)="handleNavigation($event)">
        @for (tab of tabs; track tab) {
            <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
                <ng-template matTabContent>
                    @if (activeTab === tab) {
                    <af-full-table class="w-100 h-100"
                                   [filterFields]="filterFields"
                                   (tableUpdateListener)="loadSubjects($event)"
                                   [showExport]="!hasExportImport(activeTab) && activeTab !== 'tabLoans'"
                                   [showImport]="!hasExportImport(activeTab)"
                                   [dataSource]="dataSource"
                                   [totalElements]="subjectFilterHolderService.getState(activeTab)?.response?.total"
                                   [filterEvent]="subjectFilterHolderService.getState(activeTab)?.tableEvent.filter"
                                   [pageEvent]="subjectFilterHolderService.getState(activeTab)?.tableEvent.page"
                                   [columnTranslationPrefixes]="activeTab === 'tabSuspiciousNumbers' ? {} : {id: 'subject', name: 'firstNameOrTitle'}"
                                   [exportImportMode]="activeTab === 'tabLoans' ? 'loans' : 'subjects'"
                                   (emptyStateClickListener)="navigateToCreateSubject()"
                                   [emptyStateIconName]="'ic_empty_state_no_data'"
                                   [emptyStateSearchIconName]="'ic_empty_state_no_data'"
                                   [emptyStateTitleTranslationKey]="activeTab === 'tabLoans' ? 'i18n_af_emptyStateTitleNoData' : 'i18n_af_emptyStateSubtitleNoData'"
                                   [emptyStateSearchTitleTranslationKey]="activeTab === 'tabLoans' ? 'i18n_af_emptyStateTitleNoData' : 'i18n_af_emptyStateSubtitleNoData'"
                                   [emptyStateSubtitleTranslationKey]="activeTab === 'tabLoans' ? 'i18n_af_emptyStateSubtitleNoData' : 'i18n_af_emptyStateSubtitleNewSearchResult'"
                                   [emptyStateSearchSubtitleTranslationKey]="activeTab === 'tabLoans' ? 'i18n_af_emptyStateSubtitleNoData' : 'i18n_af_emptyStateSubtitleNewSearchResult'"
                                   [emptyStateSearchButtonLabel]="''"
                                   [totalElementsTranslationKey]="activeTab === 'tabSuspiciousNumbers' ? 'i18n_af_labelTotalElementsMsisdn' : (activeTab !== 'tabLoans' ? 'i18n_af_labelTotalElementsSubject' : '')"
                                   [placeholderContext]="subjectFilterHolderService.getState(activeTab).placeholderContext"
                                   [allowSearchSpaces]="true"/>
                    }
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
</af-main-container>
